import { CurrencyPipe, DecimalPipe, PercentPipe } from "@angular/common";
import { Injectable } from "@angular/core";
import { HorizontalListFactory } from "../../../../../ui/horizontal-list/horizontal-list.factory";
import { HorizontalListData } from "../../../../../ui/horizontal-list/horizontal-list.model";
import { OfferCalculator } from "../../../../services/offer-calculator";
import { getOfferTermLabel } from "../../../../pipes/offer-term-label-pipe";

@Injectable()
export class OfferTermLoanDetailsAdapter {
  constructor(
    private readonly currencyPipe: CurrencyPipe,
    private readonly percentPipe: PercentPipe,
    private readonly decimalPipe: DecimalPipe,
  ) { }

  adaptDetailsListData = (offerCalculator: OfferCalculator, isCommissionHidden: boolean): HorizontalListData[] => {
    const factorRate = offerCalculator.rate / 100 + 1;
    return [
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Loan amount',
        displayedValue: this.formatCurrency(offerCalculator?.amount),
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Term',
        displayedValue: getOfferTermLabel(offerCalculator.term)
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Total payback',
        displayedValue: this.formatCurrency(offerCalculator?.totalPayback)
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: `Fee (${offerCalculator.drawFeeFormatted})`,
        displayedValue: this.formatCurrency(offerCalculator?.drawFee)
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Origination fee',
        displayedValue: this.formatCurrency(offerCalculator?.originationFeeAmount),
        isItemHidden: !offerCalculator?.originationFeeAmount
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Maintenance fee',
        displayedValue: this.formatCurrency(offerCalculator?.maintenanceFeeAmount),
        isItemHidden: !offerCalculator?.maintenanceFeeAmount
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Maintenance fee frequency',
        displayedValue: offerCalculator.maintenanceFeeFrequencyName,
        isItemHidden: !offerCalculator?.maintenanceFeeAmount
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Disbursed amount',
        displayedValue: this.formatCurrency(offerCalculator?.disbursedAmount),
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Factor rate',
        displayedValue: this.decimalPipe.transform(factorRate, '1.4-4'),
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: `${offerCalculator.paymentFrequencyName} payment`,
        displayedValue: this.formatCurrency(offerCalculator?.termPayment),
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: `Commissions (${this.percentPipe.transform(offerCalculator?.applicationOffer?.maxUpsell / 100, '1.2-2')})`,
        displayedValue: this.formatCurrency(offerCalculator?.commission),
        isItemHidden: isCommissionHidden
      }),
    ]
  }

  private formatCurrency(value: number): string {
    return this.currencyPipe.transform(value, 'USD', 'symbol', '1.2-2');
  }
}
